import styled from '@emotion/styled'
import { PaymentMethodSecureNotice } from './payment-method-secure-notice'

const PaymentHeader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 8px;
  margin-bottom: 8px;
`

export default function PaymentSecureHeader() {
  return (
    <PaymentHeader>
      <PaymentMethodSecureNotice />
    </PaymentHeader>
  )
}
